module.exports = __webpack_public_path__ + "static/media/soviet_air_I_152_120.fd4a0d77.png";